import script from "./DefaultView.vue?vue&type=script&setup=true&lang=js"
export * from "./DefaultView.vue?vue&type=script&setup=true&lang=js"

import "./DefaultView.vue?vue&type=style&index=0&id=a9d42828&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a9d42828"]])

export default __exports__